import moment from "moment";
import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";
import { Button, Table, Input, Spinner } from "reactstrap";
import { BiEdit, BiTrash, BiCheck, BiX } from "react-icons/bi";
import ReactQuill from "react-quill";
import { useSelector } from "react-redux";


const CustomOrderNotes = ({ orderNotes, deleteOrderNote, updateOrderNote }) => {
  const [showCount, setShowCount] = useState(2);
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [loading, setLoading] = useState(false);

  const { user } = useSelector((state) => state.auth);

  const handleShowMore = () => {
    setShowCount(orderNotes?.length);
  };

  const handleShowLess = () => {
    setShowCount(2);
  };

  const filteredNotes =
    orderNotes
      ?.filter((i) => i?.personalNote)
      ?.sort((a, b) => b.createdAt - a.createdAt) || [];

  const handleEdit = (row) => {
    setEditingId(row.id);
    setEditValue(row.message);
  };

  const handleCancel = () => {
    setEditingId(null);
    setEditValue("");
  };

  const handleSave = async (row) => {
    setLoading(true);
    await updateOrderNote(row, editValue);
    setLoading(false);
    setEditingId(null);
    setEditValue("");
  };

  const handleDelete = (row) => {
    if (window.confirm("Are you sure you want to delete this note? This action cannot be reverted.")) {
      deleteOrderNote(row);
    }
  };


  const canManage = (row) => {
    return user?.role === "Admin" || user?.role === "Super-admin" || user?._id === row.createdBy?._id;
  };

  return (
    <>
      {filteredNotes.length > 0 && (
        <Table
          responsive
          hover
          bordered
          className="shadow-sm"
          style={{
            fontSize: "13px",
            overflow: "hidden",
            borderRadius: "8px",
          }}
        >
          <thead style={{ backgroundColor: "#00509d2E" }}>
            <tr>
              <th style={{ width: "25%" }}>Date/Author</th>
              <th style={{ width: "60%" }}>Notes</th>
              <th style={{ width: "15%" }} className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody className="fs-14">
            {filteredNotes.slice(0, showCount).map((row, index) => (
              <tr
                key={row.id || index}
                style={{
                  background: index % 2 === 0 ? "#fdfdfd" : "white",
                }}
              >
                <td>
                  <div className="d-flex flex-column">
                    <span className="fw-bold text-primary fs-12">
                      {row.createdBy?.username} 
                      <span className="text-muted fw-normal ms-1">({row.createdBy?.role})</span>
                    </span>
                    <span className="text-muted fs-11 mt-1">
                      {moment(row.createdAt).format("MMM Do YYYY, h:mm a")}
                    </span>
                    {row.updatedAt && (
                      <span className="text-info fs-10 italic mt-1">
                        (Edited {moment(row.updatedAt).fromNow()})
                      </span>
                    )}
                  </div>
                </td>
                <td>
                  {editingId === row.id ? (
                    <div className="edit-note-container">
                      <ReactQuill
                        theme="snow"
                        value={editValue}
                        onChange={setEditValue}
                        className="bg-white mb-2"
                      />
                    </div>
                  ) : (
                    <div
                      className="note-content"
                      dangerouslySetInnerHTML={{
                        __html: row?.note ?? row?.message ?? "",
                      }}
                    />
                  )}
                </td>
                <td className="text-center align-middle">
                  <div className="d-flex justify-content-center gap-2">
                    {editingId === row.id ? (
                      <>
                        <Button
                          color="success"
                          size="sm"
                          className="p-1 rounded-circle d-flex align-items-center justify-content-center"
                          onClick={() => handleSave(row)}
                          disabled={loading}
                        >
                          {loading ? <Spinner size="sm" /> : <BiCheck size={18} />}
                        </Button>
                        <Button
                          color="danger"
                          size="sm"
                          className="p-1 rounded-circle d-flex align-items-center justify-content-center"
                          onClick={handleCancel}
                          disabled={loading}
                        >
                          <BiX size={18} />
                        </Button>
                      </>
                    ) : (
                      canManage(row) && (
                        <>
                          <Button
                            color="link"
                            size="sm"
                            className="p-0 text-primary hover-scale"
                            onClick={() => handleEdit(row)}
                          >
                            <BiEdit size={18} />
                          </Button>
                          <Button
                            color="link"
                            size="sm"
                            className="p-0 text-danger hover-scale"
                            onClick={() => handleDelete(row)}
                          >
                            <BiTrash size={18} />
                          </Button>
                        </>
                      )
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      {filteredNotes?.length > 2 && (
        <div className="d-flex justify-content-end">
          {showCount < filteredNotes?.length ? (
            <Button
              size="sm"
              className="mb-2 bg-primary-color border-0 shadow-sm d-flex align-items-center gap-1"
              onClick={handleShowMore}
            >
              Show More <FaChevronDown size={12} />
            </Button>
          ) : (
            <Button
              size="sm"
              className="mb-2 bg-primary-color border-0 shadow-sm d-flex align-items-center gap-1"
              onClick={handleShowLess}
            >
              Hide <FaChevronUp size={12} />
            </Button>
          )}
        </div>
      )}
    </>
  );
};

export default CustomOrderNotes;

